<template>
	<CFormGroup
		v-bind="{
			append, prepend, validFeedback, invalidFeedback,
			tooltipFeedback, description, wrapperClasses, class: computedClasses
		}"
	>
    <template #label>
		<slot name="label">
			<label v-if="label" :for="safeId" :class="labelClasses">
				{{label}}
			</label>
		</slot>
    </template>

    <template #input>
		<select
			v-bind="$attrs"
			v-on="$listeners"
			:id="safeId"
			:class="inputClasses.filter(inpClass => inpClass).join(' ') + ' ' + optionStyle"
			@change="onSelect($event)"
		>
		<option
			v-if="placeholder"
			value=""
			selected
			hidden
		>
			{{placeholder}}
		</option>
		<template v-for="(option, key) in options">
			<option
				v-if="typeof option === 'object'"
				:value="option.value"
				v-bind="option.attrs"
				:disabled="option.disabled"
				:selected="JSON.stringify(option.value) == JSON.stringify(value)"
				:data-key="key"
				:key="'selected'+key"
			>
				{{option.label || option.value}}
			</option>
			<option
				v-else
				:value="option"
				:selected="option === value"
				:data-key="key"
				:key="key"
			>
				{{option}}
			</option>
		</template>
		</select>
    </template>

    <template
		v-for="slot in $options.slots"
		#[slot]
    >
		<slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import * as allFormMixins from '@coreui/vue/src/components/form/form-mixins'
const mixins = Object.values(allFormMixins)

export default {
	name: 'CSelect',
	inheritAttrs: false,
	slots: [
		'prepend',
		'prepend-content',
		'append-content',
		'append',
		'label-after-input',
		'valid-feedback',
		'invalid-feedback',
		'description'
	],
	// props,
	// Html props: disabled, required don't use multiple
	props: {
		validFeedback: String,
		invalidFeedback: String,
		tooltipFeedback: Boolean,
		description: String,

		append: String,
		prepend: String,

		label: String,
		wasValidated: Boolean,
		isValid: {
			type: [Boolean, Function],
			default: null
		},
		addInputClasses: [String, Array, Object],
		addLabelClasses: [String, Array, Object],

		horizontal: [Boolean, Object],
		size: {
			type: String,
			validator: str => ['','sm','lg'].includes(str)
		},
		addWrapperClasses: [String, Array, Object],

		options: [Array],
		value: [String, Number, Boolean, Array, Object],
		plaintext: Boolean,
		placeholder: String,
		custom: Boolean,
		ignoreOptionStyle: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			state: this.value || undefined
		}
	},
	mixins,
	computed: {
		optionStyle() {
			if (!this.options || this.ignoreOptionStyle) {
				return ''
			}

			const option = this.options.find(option => option.value === this.value)
			if (!option) {
				return ''
			}

			return option.style || ''
		}
	},
	methods: {
		onSelect (e) {
			if (this.$attrs.multiple !== undefined) {
				return
			}

			const optionIndex = e.target.selectedOptions[0].dataset.key
			const option = this.options[optionIndex]
			const value = option.value !== undefined ? option.value : option
			this.state = value
			this.$emit('update:value', value, e)
		}
	}
}
</script>